// carousel.js
export const ismInitSwiper = (el) => {
  let autoplay = el.getAttribute('data-autoplay') || false;
  let defaultSlidesPerView = el.getAttribute('data-slides-per-view') || 1;

  new Swiper(el, {
    autoplay: autoplay ? { delay: el.getAttribute('data-autoplay-delay') || 5000 } : false,
    speed: el.getAttribute('data-speed') || 400,
    spaceBetween: el.getAttribute('data-space-between') || 24,
    slidesPerView: 'auto',
    breakpoints: {
      0: { slidesPerView: el.getAttribute('data-slides-per-view-phone') || defaultSlidesPerView },
      768: { slidesPerView: el.getAttribute('data-slides-per-view-tablet') || defaultSlidesPerView },
      1024: { slidesPerView: defaultSlidesPerView },
    },
    loop: el.getAttribute('data-loop') || false,
    pagination: {
      el: el.querySelector('.swiper-pagination'),
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: el.querySelector('.swiper-button-next'),
      prevEl: el.querySelector('.swiper-button-prev'),
    },
    effect: 'slide',
  });
};

export const ismSwiperChange = () => {
  if (!document.querySelector('#main-swiper') || !document.querySelector('#thumbs-swiper')) return;

  const mainSwiper = document.querySelector('#main-swiper').swiper;
  const thumbsSwiper = document.querySelector('#thumbs-swiper').swiper;

  thumbsSwiper.on('click', function (swiper) {
    mainSwiper.slideTo(swiper.clickedIndex);
  });
};

export const ismInitSwipers = () => {
  document.querySelectorAll('.swiper').forEach((el) => {
    ismInitSwiper(el);
  });
};
